import type { FetchRequestError } from "@lib/errors";
import { FetchUserEncodedError } from "@lib/errors/FetchUserEncodedError";

import type { MultiLanguageSettingsLocale } from "../appsMultiLanguageSettingsGetLocales";

export interface AppsMultiLanguageSettingsAddLocaleResult {
  success: boolean;
}

export interface PostAppsMultiLanguageSettingsAddLocaleProps {
  locale: Omit<MultiLanguageSettingsLocale, "id" | "created_at">;
}

export type InvalidLocalesError = FetchUserEncodedError<"INVALID_LOCALES">;

export type AddExistingLocaleError = FetchUserEncodedError<"ADD_EXISTING_LOCALE">;

export type InvalidLocaleAddError = FetchUserEncodedError<"INVALID_LOCALE_UPDATE">;

export type AddLocaleErrors = InvalidLocalesError | AddExistingLocaleError | InvalidLocaleAddError;

export const isAddLocaleError = (error: FetchRequestError): error is AddLocaleErrors => {
  return error instanceof FetchUserEncodedError;
};
